import CompetitionsPrioritiesWidget from './CompetitionsPrioritiesWidget';

export default CompetitionsPrioritiesWidget;
